import { render, staticRenderFns } from "./ForumAnswerItem.vue?vue&type=template&id=e36149f8&scoped=true"
import script from "./ForumAnswerItem.vue?vue&type=script&lang=ts"
export * from "./ForumAnswerItem.vue?vue&type=script&lang=ts"
import style0 from "./ForumAnswerItem.vue?vue&type=style&index=0&id=e36149f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e36149f8",
  null
  
)

export default component.exports